/**
 * Flippable Cards — front-end flip interaction.
 */
export class FlippableCardsFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="flippable-cards"]' ).forEach( ( block ) => {
			block.classList.add( 'flippable-cards-enhanced' );

			block.querySelectorAll( '[data-flippable-card]' ).forEach( ( card ) => {
				const flipButtons = card.querySelectorAll( '[data-flippable-card-flip]' );

				if ( ! flipButtons.length ) {
					return;
				}

				flipButtons.forEach( ( button ) => {
					button.addEventListener( 'click', () => {
						this.toggleCard( card );
					} );
				} );
			} );
		} );
	}

	/**
	 * @param {HTMLElement} card
	 */
	toggleCard( card ) {
		const flipped = card.classList.toggle( 'is-flipped' );

		card.querySelectorAll( '[data-flippable-card-flip]' ).forEach( ( button ) => {
			button.setAttribute( 'aria-pressed', flipped ? 'true' : 'false' );
		} );
	}
}
